module.exports = __webpack_public_path__ + "img/card-9.823b59b9.png";